import store from '@/store'
export default {
    inserted(el,binding){
        const {value:permissionRoles} = binding;
        const  permissions = store.getters.permissions;
        if(permissionRoles){
            const hasPermission = permissions.some(permission=>{
                return permissionRoles == permission
            })
            if(store.state.isProject || permissions !=null){
                if(!hasPermission){
                    el.parentNode && el.parentNode.removeChild(el)
                }
            }
        }else{
            throw new Error("记得传值！")
        }
    }
}